import { AfterViewInit, ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Notification } from 'src/app/models/notification';
import { User } from 'src/app/models/user';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CaseService } from 'src/app/services/case/data/case.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { ErrorService } from 'src/app/services/error/error.service';
import { MediaQueryService } from 'src/app/services/media-query/media-query.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { UserService } from 'src/app/services/user/user.service';
import { environment } from 'src/environments/environment';
import { CaseDrawerComponent } from '../../components/case-drawer/case-drawer.component';
import { InformationDrawerComponent } from '../../components/information-drawer/information-drawer.component';
import { ImageService, LanguageService } from '@/services';

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    standalone: false
})
export class MainComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('caseDrawerComponent') caseDrawerComponent: CaseDrawerComponent;
  @ViewChild('informationDrawerComponent') informationDrawerComponent: InformationDrawerComponent;
  @ViewChild('informationDrawerComponent') helpDrawerComponent: InformationDrawerComponent;

  teacher: boolean = false;

  private mobileSubscription: Subscription;
  private openCaseDrawerSubscription: Subscription;
  private languageChangeSubscription: Subscription;
  notificationToThrow: Notification;
  mobile: boolean = false;
  showNotification: boolean = false;

  instituteUrl: string = '';

  mainMenu: { icon: string; link?: string; tooltip: string; click?: string }[] = [];

  secondMenu: { icon: string; link?: string; tooltip: string; click?: string }[] = [];

  constructor(
    private authService: AuthService,
    private router: Router,
    private mediaQueryService: MediaQueryService,
    private imageService: ImageService,
    private caseService: CaseService,
    private userService: UserService,
    private errorService: ErrorService,
    private configService: ConfigService,
    private notificationService: NotificationService,
    private cd: ChangeDetectorRef,
    private ngZone: NgZone,
    private languageService: LanguageService
  ) {}

  private setNavigationMenu() {
    this.mainMenu = [
      {
        icon: 'home',
        link: 'home',
        tooltip: this.languageService.translate('main.navigation.home'),
      },
      {
        icon: 'assignment_ind',
        link: 'epd',
        tooltip: this.languageService.translate('main.navigation.epd'),
      },
      {
        icon: 'assignment',
        tooltip: this.languageService.translate('main.navigation.cases'),
        click: 'casussen',
      },
      {
        icon: 'info_outline',
        tooltip: this.languageService.translate('main.navigation.information'),
        click: 'informatie',
      },
    ];
    this.secondMenu = [
      {
        icon: 'exit_to_app',
        link: 'uitloggen',
        tooltip: this.languageService.translate('main.navigation.logout'),
      },
    ];
  }

  ngOnInit(): void {
    this.mobileSubscription = this.mediaQueryService.mobile.subscribe((mobile: boolean) => {
      this.mobile = mobile;
    });

    // var loginObj = this.authService.isLoggedIn();
    // if (!loginObj.login) {
    //   this.router.navigateByUrl('/uitloggen');
    //   this.notificationService.warning(
    //     this.languageService.translate('main.notifications.session-expired')
    //   );
    //   return;
    // }

    this.setNavigationMenu();
    this.setUserSpecificNavigation();

    var first = true;
    this.openCaseDrawerSubscription = this.caseService.openCaseDrawerSub.subscribe(() => {
      if (!first) {
        this.caseDrawerComponent.openCaseDrawer();
      }
      first = false;
    });

    this.configService.getConfigurationValueByProperty('institute_logo_id').subscribe(
      resp => {
        this.instituteUrl = this.imageService.buildImageUrl(resp);
      },
      err => this.errorService.onError(err)
    );
  }

  private setUserSpecificNavigation() {
    this.userService.getCurrentUser().subscribe({
      next: user => {
        if (user.firstLogin) {
          this.router.navigateByUrl(`/login?token=${this.authService.getToken()}&first=true`);
        }
        if (this.authService.isUserTeacher() || this.authService.isUserAdmin()) {
          this.mainMenu.push({
            icon: 'groups',
            link: 'beheer',
            tooltip: this.languageService.translate('main.navigation.management'),
          });
        }

        this.secondMenu = [];
        this.secondMenu.push({
          icon: 'help_outline',
          click: 'help',
          tooltip: this.languageService.translate('main.navigation.help'),
        });
        this.secondMenu.push({
          icon: 'person',
          link: 'account',
          tooltip: `${user.firstname} ${user.lastname}`,
        });
        this.secondMenu.push({
          icon: 'exit_to_app',
          link: 'uitloggen',
          tooltip: this.languageService.translate('main.navigation.logout'),
        });
      },
      error: err => this.errorService.onError(err),
    });
  }

  ngAfterViewInit() {
    this.notificationService.customNotificationData.subscribe(resp => {
      let notification = resp as Notification;
      if (notification && notification.visible) {
        this.ngZone.run(() => {
          this.notificationToThrow = resp as Notification;
          this.notificationToThrow.visible = true;
          this.notificationService.updateNotificationResultStatus('active');
          this.showNotification = true;
          this.cd.detectChanges();
        });
      }
    });
  }

  handleCancelBtn() {
    this.notificationService.updateNotificationUserResponse(false);
    this.notificationService.updateNotificationUserResponse(null);
    let subscription = this.notificationService.notificationResultStatusData.subscribe(resp => {
      if ((resp as string) == 'done') {
        this.notificationToThrow.visible = false;
        this.notificationService.updateNotification(this.notificationToThrow);
      }
    });
  }
  handleOkBtn() {
    this.notificationService.updateNotificationUserResponse(true);
    this.notificationService.updateNotificationUserResponse(null);
    let subscription = this.notificationService.notificationResultStatusData.subscribe(resp => {
      if ((resp as string) == 'done') {
        this.notificationToThrow.visible = false;
      }
    });
  }

  ngOnDestroy(): void {
    if (this.mobileSubscription) {
      this.mobileSubscription.unsubscribe();
    }
    if (this.openCaseDrawerSubscription) {
      this.openCaseDrawerSubscription.unsubscribe();
    }
  }

  open(link: string | undefined) {
    if (link == 'casussen') {
      if (this.authService.isUserTeacher() || this.authService.isUserAdmin()) {
        this.router.navigateByUrl('casussen');
      } else {
        this.caseDrawerComponent.openCaseDrawer();
      }
    } else if (link == 'informatie') {
      this.informationDrawerComponent.openDrawer('information_url');
    } else if ((link = 'help')) {
      const userRole = this.authService.getLoggedInUserRole();
      switch (userRole.name) {
        case 'ROLE_USER':
        default:
          this.informationDrawerComponent.openDrawer('help_student_url');
          break;
        case 'ROLE_TEACHER':
          this.informationDrawerComponent.openDrawer('help_teacher_url');
          break;
        case 'ROLE_ADMIN':
        case 'ROLE_SUPERADMIN':
          this.informationDrawerComponent.openDrawer('help_admin_url');
          break;
      }
    }
  }
}
